<template>
    <div class="view">
        <modal @next="swtch" v-if="modal"/>
        <headerBar @viewIncrement="getView" :user-name="authorName"/>
        <chat ref="chat" @finishChat="getView" :user-name="authorName"/>
        <footerDown :view="view"/>
    </div>
</template>

<script>
    import 'reset.css'
    import 'normalize.css'
    import 'vue2-animate/dist/vue2-animate.css'
    import './assets/styles/animations.css'
    import modal from './components/Modal'
    import headerBar from './components/header'
    import chat from './components/views/chat'
    import footerDown from './components/footer'

    export default {
        data: () => ({
            view: 1,
            authorName: "Olivia",
            modal: true
        }),
        components: {
            modal,headerBar, chat, footerDown
        },
        methods: {
            getView(view) {
                this.view = this.view + view;
            },
            swtch() {
                this.modal = false;
                this.$refs.chat.dialog()
            }
        }
    }
</script>

<style lang="scss">

    * {
        box-sizing: border-box;
    }

    .view {
        position: relative;
    }
</style>
